module.exports = __webpack_public_path__ + "img/wechat.d0e94ea3.png";